import { OrganizationManagementComponent } from './../organization-management/organization-management.component';
import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../services/global-environment';
import { finalize, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ActivatedRoute } from '@angular/router'; // 新增這行

// 組織節點類型定義
type NodeType = 'company' | 'department' | 'team' | 'user';

// 組織節點介面
interface OrganizationNode {
  id: string;
  name: string;
  type: NodeType;
  role?: string;
  children?: OrganizationNode[];
}

// 組織結構介面
interface OrganizationData {
  companyid: string;
  assistantNo: string;
  id: string;
  name: string;
  type: NodeType;
  children: OrganizationNode[];
}

// API 響應介面
interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

@Component({
  selector: 'app-regulation-advance-setting',
  standalone: true,
  imports: [CommonModule, FormsModule, OrganizationManagementComponent],
  templateUrl: './regulation-advance-setting.component.html',
  styleUrls: ['./regulation-advance-setting.component.scss']
})
export class RegulationAdvanceSettingComponent implements OnInit {
  // API URL
  private apiUrl = environment.apiUrl;
  private companyid = environment.companyid;

  assistantNo = ''; // 預設值

  // 工具列表
  tools = [
    {
      name: '既有資料匯入工具',
      icon: 'fa-file-import',
      description: '將 Excel 資料匯入系統'
    },
    {
      name: '鑑別群組設定',
      icon: 'fa-sitemap',
      description: '設定法規鑑別的組織架構與人員'
    }
  ];

  // 界面狀態控制
  activeToolIndex: number | null = null;
  isLoadingOrg = false;
  isProcessing = false;
  isAddingNode = false;
  isCreatingOrganization = false;

  // 組織數據
  organizationData: OrganizationData | null = null;
  selectedNode: OrganizationNode | null = null;
  parentNode: OrganizationNode | null = null;

  // 編輯狀態
  editingNode: Partial<OrganizationNode> = {};
  newNode: Partial<OrganizationNode> = {};
  newOrganization: Partial<OrganizationData> = {};

  // 既有資料匯入相關屬性
  selectedFile: File | null = null;
  isSubmitting = false;
  isInserting = false;
  apiResponse: any = null;

  formData = {
    topic: '',
    title: '',
    startDate: '',
    endDate: '',
    note: ''
  };

  // 成員編輯相關
  isEditingMember = false;

  constructor(private http: HttpClient,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    // 初始化邏輯

    this.getassistantNo();
  }


 getassistantNo(){
    // 從 URL 查詢參數中取得 id 的值
    this.route.queryParams.subscribe(params => {
      const id = params['id'];
      if (id) {
        this.assistantNo = id;
        console.log('取得 assistantNo:', this.assistantNo);

        // 如果需要在取得 assistantNo 後重新載入鑑別群組，可以呼叫以下方法
        // this.getmissionGroups();
      } else {
        console.warn('URL 中未找到 id 參數');
        // 如果沒有 id 參數，可以設定預設值或顯示錯誤
        this.assistantNo = '';
      }
    });
  }

  // 工具選擇
  selectTool(index: number): void {
    this.activeToolIndex = index;

    // 如果選擇鑑別群組工具，載入組織數據
    if (index === 1) {
      this.loadOrganizationData();
    }
  }

  closeToolPanel(): void {
    this.activeToolIndex = null;
    this.resetForm();
  }

  resetForm(): void {
    // 重置匯入工具表單
    this.selectedFile = null;
    this.apiResponse = null;
    this.formData = {
      topic: '',
      title: '',
      startDate: '',
      endDate: '',
      note: ''
    };

    // 重置組織編輯狀態
    this.selectedNode = null;
    this.parentNode = null;
    this.editingNode = {};
    this.newNode = {};
    this.isAddingNode = false;
    this.isCreatingOrganization = false;
  }

  // 既有資料匯入工具方法
  onFileSelected(event: Event): void {
    const element = event.target as HTMLInputElement;
    if (element.files && element.files.length > 0) {
      this.selectedFile = element.files[0];
    }
  }

    submitForm(): void {
    if (!this.selectedFile || !this.formData.topic || !this.formData.title) {
      this.apiResponse = {
        success: false,
        message: '請選擇檔案並填寫必填欄位（主題和任務名稱）'
      };
      return;
    }

    this.isSubmitting = true;
    this.apiResponse = null;

    // 準備表單資料
    const formData = new FormData();
    formData.append('file', this.selectedFile);
    formData.append('companyid', environment.companyid);
    formData.append('topic', this.formData.topic);
    formData.append('title', this.formData.title);

    if (this.formData.startDate) {
      formData.append('startDate', this.formData.startDate);
    }

    if (this.formData.endDate) {
      formData.append('endDate', this.formData.endDate);
    }

    if (this.formData.note) {
      formData.append('note', this.formData.note);
    }

    // 呼叫 API
    const apiUrl = `${environment.apiUrl}/api/importTools/compliancelist`;

    this.http.post(apiUrl, formData).subscribe({
      next: (response: any) => {

        console.log('API Response:', response);
        this.isSubmitting = false;

        // 設置 API 回應結果
        this.apiResponse = {
          success: true,
          message: '資料匯入成功',
          data: response
        };

        // 顯示匯入資訊
        if (response) {
          let importSummary = '';

          if (response.law_check_info) {
            importSummary += `任務資訊：${response.law_check_info.title} (${response.law_check_info.topic})\n`;
          }

          if (response.law_list) {
            importSummary += `匯入法規數量：${response.law_list.length}部\n`;
          }

          if (response.law_check_result) {
            importSummary += `匯入判別結果：${response.law_check_result.length}筆`;
          }

          this.apiResponse.message = `資料匯入成功！\n${importSummary}`;
        }
      },
      error: (error) => {
        this.isSubmitting = false;
        this.apiResponse = {
          success: false,
          message: `匯入失敗: ${error.error?.message || error.message || '未知錯誤'}`
        };
        console.error('API Error:', error);
      }
    });
  }

  downloadJson(): void {
    if (!this.apiResponse || !this.apiResponse.data) return;

    const jsonData = JSON.stringify(this.apiResponse.data, null, 2);
    const blob = new Blob([jsonData], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `data-export-${new Date().getTime()}.json`;
    link.click();

    window.URL.revokeObjectURL(url);
  }

 InsertHistorydata(): void {
    if (!this.apiResponse || !this.apiResponse.data) {
      console.error('No data available to insert');
      return;
    }

    this.isInserting = true;

    // 準備要寫入資料庫的資料
    const dataToInsert = {
      law_list: this.apiResponse.data.law_list,
      law_check_info: this.apiResponse.data.law_check_info,
      law_check_result: this.apiResponse.data.law_check_result
    };

    // 呼叫寫入資料庫的 API
    const apiUrl = `${environment.apiUrl}/api/importTools/InsertHistorydata`;

    this.http.post(apiUrl, dataToInsert).subscribe({
      next: (response: any) => {
        console.log('Insert successful:', response);
        this.isInserting = false;

        if (response.success) {
          // 建立成功訊息，顯示插入資料的細節
          let successMessage = `資料已成功寫入資料庫！\n\n`;

          if (response.results) {
            const results = response.results;
            if (results.law_check_info?.success) {
              // 顯示任務名稱而非ID
              const taskTitle = this.apiResponse?.data?.law_check_info?.title || results.law_check_info.title || '';
              successMessage += `✓ 成功建立任務: ${taskTitle}\n`;
            }

            // 預期筆數
            // const expectedLawListCount = this.apiResponse?.data?.law_list?.length ?? 0;
            const expectedResultCount = this.apiResponse?.data?.law_check_result?.length ?? 0;

            // 實際插入筆數
            // const insertedLawListCount = results.law_list?.insertedCount ?? 0;
            const insertedResultCount = results.law_check_result?.insertedCount ?? 0;

            // if (results.law_list?.success) {
            //   successMessage += `✓ 成功插入 ${insertedLawListCount} 條法規資料`;
            //   if (insertedLawListCount < expectedLawListCount) {
            //     const failed = expectedLawListCount - insertedLawListCount;
            //     successMessage += `（有 ${failed} 筆法規資料插入失敗）`;
            //   }
            //   successMessage += `\n`;
            // }

            if (results.law_check_result?.success) {
              successMessage += `✓ 成功插入 ${insertedResultCount} 筆判別結果`;
              if (insertedResultCount < expectedResultCount) {
                const failed = expectedResultCount - insertedResultCount;
                successMessage += `（有 ${failed} 筆判別結果插入失敗）`;
              }
              successMessage += `\n`;
            }
          }

          // 顯示成功訊息
          alert(successMessage);

          // 重設表單
          this.resetForm();
        } else {
          // 處理 API 回傳成功但操作失敗的情況
          alert(`操作未完成: ${response.message || '未知錯誤'}`);
        }
      },
      error: (error) => {
        console.error('Insert error:', error);
        this.isInserting = false;

        // 顯示錯誤訊息
        let errorMessage = `寫入資料庫失敗`;

        if (error.error) {
          if (error.error.message) {
            errorMessage += `: ${error.error.message}`;
          } else if (error.message) {
            errorMessage += `: ${error.message}`;
          }
        }

        alert(errorMessage);
      }
    });
  }

  // 組織結構管理方法
  loadOrganizationData(): void {
    this.isLoadingOrg = true;

    const url = `${this.apiUrl}/api/departments/${this.companyid}/${this.assistantNo}`;

    this.http.get<ApiResponse<OrganizationData>>(url)
      .pipe(
        catchError(this.handleError<ApiResponse<OrganizationData>>('載入組織結構')),
        finalize(() => this.isLoadingOrg = false)
      )
      .subscribe(response => {
        if (response.success && response.data) {
          this.organizationData = response.data;
        } else {
          this.organizationData = null;
        }
      });
  }

  // 移除組織管理相關的方法
  // refreshOrganizationData(), createNewOrganization(), selectNode() 等組織管理相關方法已移到獨立元件

  // 輔助方法
  getNodeTypeText(type?: NodeType): string {
    type = type || this.selectedNode?.type || 'company';

    switch (type) {
      case 'company': return '公司';
      case 'department': return '部門';
      case 'team': return '小組';
      case 'user': return '成員';
      default: return '節點';
    }
  }

  getNewNodeTypeText(): string {
    return this.getNodeTypeText(this.newNode.type);
  }

  isDirty(): boolean {
    if (!this.selectedNode) return false;

    return this.selectedNode.name !== this.editingNode.name ||
           this.selectedNode.role !== this.editingNode.role;
  }

  findNodeById(root: OrganizationData | null, id: string): OrganizationNode | null {
    if (!root) return null;

    if (root.id === id) {
      return root;
    }

    return this.searchInChildren(root.children, id);
  }

  searchInChildren(children: OrganizationNode[] | undefined, id: string): OrganizationNode | null {
    if (!children) return null;

    for (const child of children) {
      if (child.id === id) {
        return child;
      }

      const result = this.searchInChildren(child.children, id);
      if (result) {
        return result;
      }
    }

    return null;
  }

  private handleError<T>(operation = 'operation') {
    return (error: HttpErrorResponse) => {
      console.error(`${operation} 失敗:`, error);

      // 顯示用戶友好錯誤訊息
      alert(`操作失敗: ${error.error?.message || error.message || '未知錯誤'}`);

      // 返回包含錯誤的結果
      return of({
        success: false,
        error: 'API錯誤',
        message: error.error?.message || error.message
      } as T);
    };
  }

}
